// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2akrz","list":"BalanceDue_list__235wf","listRow":"BalanceDue_listRow__3Plbh","total":"BalanceDue_total__Fs74E"};